'use strict';exports.__esModule = true; /* eslint-disable max-len */
var smilAnimation = '\n  <animateTransform\n    xlink:href="#pinIcon"\n    attributeName="transform"\n    type="translate"\n    from="0 0"\n    to="0 0"\n    dur="2s"\n    begin="0s"\n    values="0 0;0 0;0 0;0 0;0 -16;0 0;0 -8;0 0;0 0;0 0;"\n    repeatCount="indefinite"\n  />';











var cssAnimation = '\n  <style>\n    #pinIcon {\n      animation: bounce 2s infinite;\n      -webkit-animation: bounce 2s infinite;\n      -o-animation: bounce 2s infinite;\n    }\n    @-webkit-keyframes bounce {\n      0%, 20%, 50%, 80%, 100% {-webkit-transform: translateY(0);}\n      40% {-webkit-transform: translateY(-10px);}\n      60% {-webkit-transform: translateY(-8px);}\n    }\n    @-o-keyframes bounce {\n      0%, 20%, 50%, 80%, 100% {-o-transform: translateY(0);}\n      40% {-o-transform: translateY(-10px);}\n      60% {-o-transform: translateY(-8px);}\n    }\n    @keyframes bounce {\n      0%, 20%, 50%, 80%, 100% {transform: translateY(0);}\n      40% {transform: translateY(-10px);}\n      60% {transform: translateY(-8px);}\n    }\n  </style>';























var propertyPin = '<svg style="overflow: visible" width="{iconWidth}px" height="{iconHeight}px" viewBox="{iconViewBox}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n      <title>{title}</title>\n      {animation}\n      <defs>\n        <filter x="-10.7%" y="-15.2%" width="121.5%" height="130.5%" filterUnits="objectBoundingBox" id="filter-1">\n            <feGaussianBlur stdDeviation="0.5893866" in="SourceGraphic"></feGaussianBlur>\n        </filter>\n      </defs>\n      <g id="pinIcon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="\u05D4" transform="translate(-620.500000, -435.000000)">\n            <g id="Pin_3" transform="translate(621.000000, 435.000000)">\n                <g id="Pin">\n                    <path d="M5.58464291,16.8018039 C6.15356588,17.3859777 6.85239121,17.835501 7.69321201,18.0376108 L8.67197505,19.3548387 L13.152856,18.0376108 C13.152856,18.0376108 13.1648321,18.032064 13.1875835,18.0212812 C16.5677902,17.3141082 19,15.3426367 19,13.0212072 C19,10.1055459 15.1632441,7.74193548 10.4303658,7.74193548 C5.69748746,7.74193548 2.53333333,8.78392121 2.53333333,11.6995825 C2.53333333,13.4425264 3.66404103,15.460477 5.58464291,16.8018039 Z" id="Combined-Shape" fill-opacity="0.3" fill="#000000" filter="url(#filter-1)"></path>\n                    <g id="Group">\n                        <path d="M9.5,19.9465245 L12.6291342,17.6406206 C16.1136307,16.2575714 18.43,12.9287048 18.43,9.09677419 C18.43,4.07990815 14.4248902,0 9.5,0 C4.57510983,0 0.57,4.07990815 0.57,9.09677419 C0.57,12.9287048 2.88636927,16.2575714 6.37086583,17.6406206 L9.5,19.9465245 Z" id="Path" fill="#FFFFFF"></path>\n                        <path d="M9.5,19.9465245 L12.6291342,17.6406206 C16.1136307,16.2575714 18.43,12.9287048 18.43,9.09677419 C18.43,4.07990815 14.4248902,0 9.5,0 C4.57510983,0 0.57,4.07990815 0.57,9.09677419 C0.57,12.9287048 2.88636927,16.2575714 6.37086583,17.6406206 L9.5,19.9465245 Z M6.70893793,17.093476 L6.63701004,17.0537595 C3.37165946,15.7744005 1.20333333,12.6715326 1.20333333,9.09677419 C1.20333333,4.43622089 4.92489017,0.64516129 9.5,0.64516129 C14.0751098,0.64516129 17.7966667,4.43622089 17.7966667,9.09677419 C17.7966667,12.6715326 15.6283405,15.7744005 12.36299,17.0537595 L12.2910621,17.093476 L9.5,19.1502497 L6.70893793,17.093476 Z" id="Shape" fill="#999999" fill-rule="nonzero"></path>\n                        <ellipse id="Oval" fill="{iconColor}" cx="9.5" cy="9.03214305" rx="6.175" ry="6.17500019"></ellipse>\n                    </g>\n                    {numberElement}\n                    {favoriteElement}\n                </g>\n            </g>\n        </g>\n    </g>\n    </svg>';

























var bigPin = '<svg width="{iconWidth}px" height="{iconWidth}px" viewBox="{iconViewBox}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <title>{title}</title>\n    {animation}\n    <defs></defs>\n    <g id="pinIcon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="Artboard" transform="translate(-463.000000, -185.000000)">\n            <g id="Big-Pin-Copy-3" transform="translate(464.000000, 186.000000)">\n                <g id="Big-Pin-Copy-10">\n                    <g id="Group">\n                        <circle id="Combined-Shape" stroke="#979797" stroke-width="0.6" fill="#FFFFFF" cx="15.2604694" cy="15" r="15"></circle>\n                        <circle id="Oval" fill="#00A6EE" cx="15.2604694" cy="15" r="13"></circle>\n                        <circle id="Oval" fill="#FFFFFF" cx="15.2604694" cy="15" r="9.5"></circle>\n                    </g>\n                </g>\n                {numberElement}\n            </g>\n        </g>\n    </g>\n</svg>';



















var agencyPin = '<svg width="{iconWidth}px" height="{iconHeight}" viewBox="{iconViewBox}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <title>{title}</title>\n    <defs>\n        <filter x="-10.7%" y="-15.4%" width="121.4%" height="130.7%" filterUnits="objectBoundingBox" id="filter-1">\n            <feGaussianBlur stdDeviation="0.7627356" in="SourceGraphic"></feGaussianBlur>\n        </filter>\n    </defs>\n    <g id="RTL" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="Artboard" transform="translate(-216.000000, -868.000000)">\n            <g id="Company_Pin" transform="translate(216.000000, 868.000000)">\n                <g>\n                    <path d="M7.2417185,21.5584257 C7.97945232,22.3079802 8.88563315,22.8847643 9.97594234,23.1440919 L11.245124,24.8342294 L17.0555722,23.1440919 C17.0555722,23.1440919 17.0711019,23.1369747 17.100604,23.1231393 C21.4837859,22.2157643 24.6376812,19.6861655 24.6376812,16.707535 C24.6376812,12.9664447 19.6624828,9.93369176 13.5252645,9.93369176 C7.38804629,9.93369176 3.28502415,11.2706656 3.28502415,15.0117559 C3.28502415,17.2481305 4.75123551,19.8373666 7.2417185,21.5584257 Z" id="Combined-Shape" fill-opacity="0.3" fill="#000000" filter="url(#filter-1)"></path>\n                    <g id="Group">\n                        <path d="M12.3188406,25.5934225 L16.3764516,22.634713 C20.8948682,20.8601199 23.8985507,16.588845 23.8985507,11.6720878 C23.8985507,5.2349377 18.7050445,0 12.3188406,0 C5.9326367,0 0.739130435,5.2349377 0.739130435,11.6720878 C0.739130435,16.588845 3.74281294,20.8601199 8.26122953,22.634713 L12.3188406,25.5934225 Z" id="Path" fill="#FFFFFF"></path>\n                        <path d="M12.3188406,25.5934225 L16.3764516,22.634713 C20.8948682,20.8601199 23.8985507,16.588845 23.8985507,11.6720878 C23.8985507,5.2349377 18.7050445,0 12.3188406,0 C5.9326367,0 0.739130435,5.2349377 0.739130435,11.6720878 C0.739130435,16.588845 3.74281294,20.8601199 8.26122953,22.634713 L12.3188406,25.5934225 Z M8.69961441,21.9326707 L8.60634407,21.8817104 C4.37209846,20.2401625 1.56038647,16.258867 1.56038647,11.6720878 C1.56038647,5.69212324 6.38620388,0.827807646 12.3188406,0.827807646 C18.2514773,0.827807646 23.0772947,5.69212324 23.0772947,11.6720878 C23.0772947,16.258867 20.2655827,20.2401625 16.0313371,21.8817104 L15.9380668,21.9326707 L12.3188406,24.5717208 L8.69961441,21.9326707 Z" id="Shape" fill="#999999" fill-rule="nonzero"></path>\n                        <circle id="Oval" fill="#FF3B30" cx="12.3478261" cy="11.5999999" r="8"></circle>\n                        <g id="Group-5" transform="translate(6.847813, 7.000000)" fill-rule="nonzero" fill="#FFFFFF">\n                            <path d="M5.27434999,0.691396977 C2.77749186,2.10491243 1.52906279,2.81317939 1.52906279,2.81619784 C1.52363295,2.84547368 1.52249223,4.71351379 1.52249223,4.71815999 L1.52249223,8.27190433 C1.52249223,8.38919733 1.56376356,8.49084494 1.64628339,8.57644418 C1.72878041,8.66209082 1.79330577,8.70528158 1.93938053,8.70518675 L4.44052778,8.70518675 L4.44052778,5.02291744 L6.10819503,5.02291744 L6.10819503,8.70528158 L8.60931946,8.70528158 C8.72220532,8.70528158 8.82003365,8.66228046 8.9024166,8.57644418 C8.98493643,8.49093976 9.02634465,8.38922103 9.02634465,8.27190433 L9.02634465,3.93999584 C9.02634465,3.92197994 9.02397194,2.82503986 9.01977409,2.81619784 L5.27434999,0.691396977 Z" id="Shape"></path>\n                            <path d="M10.4526123,3.16636191 L5.76942338,0.199216506 C5.63062032,0.0820038875 5.46558065,0.0234094203 5.27448688,0.0234094203 C5.08341593,0.0234094203 4.91839907,0.0820038875 4.77945912,0.199216506 L0.0959964445,3.16636191 C0.0525805618,3.20236174 0.0287850991,3.25081941 0.0243590974,3.31168755 C0.0199559101,3.37250833 0.0351275139,3.42563177 0.0699195376,3.47067893 L0.473757971,3.97107662 C0.508549995,4.01162381 0.554087621,4.03642106 0.610553364,4.04549207 C0.662684364,4.05003942 0.714815363,4.03421844 0.766946363,3.99817124 L5.27434999,1.17973831 L9.78179926,3.99814755 C9.81661409,4.02960004 9.86212891,4.0453026 9.91859465,4.0453026 C9.99454393,4.03639738 10.0399903,4.01143433 10.0749648,3.97098189 L10.4788489,3.47065524 C10.5135725,3.42551334 10.5287897,3.37248464 10.5242724,3.31159282 C10.5198236,3.25089046 10.4959369,3.20243279 10.4526123,3.16636191 Z" id="Shape"></path>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>';


























var getNumberElement = function getNumberElement(number) {var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},family = _ref.family,size = _ref.size,weight = _ref.weight,color = _ref.color;var offset = arguments[2];var one = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;var shorten = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;return number && number > +!one ? '<text id="12" font-family="' +
  family + '" font-size="' + size + '" font-weight="' + weight + '" fill="' + color + '">\n      <tspan x="48%" y="' +
  offset + '" text-anchor="middle">' + (shorten && number > 9 ? '9+' : number) + '</tspan>\n   </text>' :
  '';};

var favoriteElement = '\n  <g id="Heart" transform="translate(5.500000, 5.700012)">\n    <path d="M7.70970862,3.0762293 C7.54965413,3.75349691 7.1814182,4.36791997 6.64492099,4.85381868 L3.9622844,7.24722271 L3.72536404,7.0321928 L1.32278187,4.85159821 C0.788040244,4.36817854 0.419637572,3.75366729 0.259695124,3.07608954 C0.171572477,2.70252614 0.163744169,2.40474936 0.19328013,2.23554603 C0.309656792,0.952138057 1.23906538,0 2.41421306,0 C3.01345996,0 3.56632676,0.249618808 3.96955008,0.683022441 C4.38171787,0.252408908 4.95052956,0 5.55522368,0 C6.72689425,0 7.65443236,0.946746771 7.77496606,2.22446067 C7.80458779,2.42519618 7.79569673,2.71168019 7.70970862,3.0762293 Z M6.16953019,4.3249751 C6.59850428,3.93644799 6.89109348,3.44824589 7.01762534,2.9128288 C7.08346077,2.63371747 7.08852559,2.43585599 7.07070264,2.3232301 L7.06778056,2.29971202 C6.9832928,1.36643647 6.34361139,0.711111111 5.55522368,0.711111111 C5.03241756,0.711111111 4.54645276,0.992697501 4.27084379,1.45380991 L3.96210776,1.9703461 L3.65862117,1.45070828 C3.38603478,0.983978591 2.92577508,0.711111111 2.41421306,0.711111111 C1.62573469,0.711111111 0.986124384,1.36636362 0.898004516,2.32668252 C0.880479796,2.43077935 0.885795448,2.63297855 0.951797852,2.91277137 C1.07822284,3.44835625 1.37080174,3.93639023 1.80018006,4.32455979 L3.96636073,6.29059445 L6.16953019,4.3249751 Z" id="Fill-1" fill="#FFFFFF" fill-rule="nonzero"></path>\n    <path d="M6.16953019,4.3249751 C6.59850428,3.93644799 6.89109348,3.44824589 7.01762534,2.9128288 C7.08346077,2.63371747 7.08852559,2.43585599 7.07070264,2.3232301 L7.06778056,2.29971202 C6.9832928,1.36643647 6.34361139,0.711111111 5.55522368,0.711111111 C5.03241756,0.711111111 4.54645276,0.992697501 4.27084379,1.45380991 L3.96210776,1.9703461 L3.65862117,1.45070828 C3.38603478,0.983978591 2.92577508,0.711111111 2.41421306,0.711111111 C1.62573469,0.711111111 0.986124384,1.36636362 0.898004516,2.32668252 C0.880479796,2.43077935 0.885795448,2.63297855 0.951797852,2.91277137 C1.07822284,3.44835625 1.37080174,3.93639023 1.80018006,4.32455979 L3.96636073,6.29059445 L6.16953019,4.3249751 Z" id="Path" fill="#FF2D55"></path>\n  </g>';




/* eslint-disable max-len */

var getPin = function getPin(type) {
  switch (type) {
    case 'big':
      return bigPin;

    case 'property':
    case 'favorite':
    case 'project':
      return propertyPin;

    case 'agency':
      return agencyPin;

    default:
      console.error('Unknown pin type:', type);
      return '';}

};

var bigPinOptions = {
  title: 'Big Pin',
  iconViewBox: '0 0 31 32',
  iconHeight: 32,
  iconWidth: 31,
  iconColor: '#00A6EE',
  font: {
    family: 'Arial-BoldMT, Arial, serif',
    size: 10,
    weight: 'bold',
    color: '#000' },

  textOffset: 18,
  withOne: true,
  shorten: false };


var bigPinAnimationOptions = {
  iconViewBox: '0 -16 31 46',
  iconHeight: 46 };


var propertyPinOptions = {
  title: 'Property Pin',
  iconWidth: 40,
  iconHeight: 40,
  iconViewBox: '0 0 20 20',
  iconColor: '#00A6EE',
  font: {
    family: 'Assistant-SemiBold, Assistant, Tahoma, serif',
    size: 9,
    weight: 700,
    color: '#fff' },

  textOffset: 12,
  shorten: true };


var projectPinOptions = {
  title: 'Project Pin',
  iconWidth: 40,
  iconHeight: 40,
  iconViewBox: '0 0 20 20',
  iconColor: '#50C716',
  font: {
    family: 'Assistant-SemiBold, Assistant, Tahoma, serif',
    size: 9,
    weight: 700,
    color: '#fff' },

  textOffset: 12,
  shorten: true };


var propertyPinAnimationOptions = {
  iconViewBox: '0 -10 20 20',
  iconHeight: 40 };


var projectPinAnimationOptions = {
  iconViewBox: '0 -10 20 20',
  iconHeight: 40 };


var reviewedPinOptions = {
  iconColor: '#87d2f8' };


var reviewedProjectPinOptions = {
  iconColor: '#7ad192' };


var agencyPinOptions = {
  title: 'Agency Pin',
  iconWidth: 52,
  iconHeight: 52,
  iconViewBox: '0 0 26 26' };


var getPinOptions = function getPinOptions(type) {
  switch (type) {
    case 'big':
      return Object.assign({}, bigPinOptions);

    case 'big-animated':
    case 'big-reviewed-animated':
      return Object.assign({},
      bigPinOptions,
      bigPinAnimationOptions);


    case 'property':
    case 'favorite':
      return Object.assign({}, propertyPinOptions);

    case 'property-reviewed':
    case 'favorite-reviewed':
      return Object.assign({},
      propertyPinOptions,
      reviewedPinOptions);


    case 'property-reviewed-animated':
    case 'favorite-reviewed-animated':
      return Object.assign({},
      propertyPinOptions,
      reviewedPinOptions,
      propertyPinAnimationOptions);


    case 'property-animated': // eslint-disable-line no-fallthrough
    case 'favorite-animated': // eslint-disable-line no-fallthrough
      return Object.assign({},
      propertyPinOptions,
      propertyPinAnimationOptions);


    case 'agency':
      return Object.assign({},
      agencyPinOptions);


    case 'project':
      return Object.assign({},
      projectPinOptions);


    case 'project-reviewed':
      return Object.assign({},
      projectPinOptions,
      reviewedProjectPinOptions);


    case 'project-reviewed-animated':
      return Object.assign({},
      projectPinOptions,
      reviewedProjectPinOptions,
      projectPinAnimationOptions);


    case 'project-animated':
      return Object.assign({},
      projectPinOptions,
      projectPinAnimationOptions);


    default:
      console.error('Unknown pin option type:', type);
      return {};}

};

var memoizedPins = {};

var customMapPin = function customMapPin() {var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'property';var animated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;var reviewed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;var isFirefox = arguments[4];var isMapbox = arguments[5];
  var pinString = getPin(type);
  var fullType = type;

  if (reviewed) {
    fullType = fullType + '-reviewed';
  }

  if (animated) {
    fullType = fullType + '-animated';
  }

  var mapboxPostfix = isMapbox ? '_mb' : '';
  var id = fullType + '_' + number + mapboxPostfix;

  if (memoizedPins[id]) {
    return memoizedPins[id];
  }

  var pinOptions = getPinOptions(fullType);
  var numberElement = getNumberElement(
  number,
  pinOptions.font,
  pinOptions.textOffset,
  pinOptions.withOne,
  pinOptions.shorten);


  if (numberElement) {
    pinOptions.numberElement = numberElement;
  }

  if (type === 'favorite') {
    pinOptions.favoriteElement = favoriteElement;
  }

  if (animated) {
    pinOptions.animation = isFirefox ? smilAnimation : cssAnimation;
  }

  var pin = pinString;
  for (var _iterator = Object.keys(pinOptions), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {var _ref2;if (_isArray) {if (_i >= _iterator.length) break;_ref2 = _iterator[_i++];} else {_i = _iterator.next();if (_i.done) break;_ref2 = _i.value;}var key = _ref2;
    pin = pin.replace('{' + key + '}', pinOptions[key]);
  }

  var result = isMapbox ? pin : 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(pin);

  memoizedPins[id] = result;

  return result;
};

var clearMemoizedPins = exports.clearMemoizedPins = function clearMemoizedPins() {
  memoizedPins = {};
};exports.default =

customMapPin;

var dPin = '\n<svg width="30px" height="31px" viewBox="0 0 30 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <g id="Welcome" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="Artboard" transform="translate(-668.000000, -156.000000)">\n            <g id="Pin" transform="translate(668.000000, 156.000000)">\n                <g id="Group">\n                    <path d="M28.6,14.1 C28.6,6.6 22.5,0.5 15,0.5 C7.5,0.5 1.4,6.6 1.4,14.1 C1.4,20 5.1,24.9 10.3,26.9 L15,30.3 L19.7,26.9 C24.9,24.9 28.6,20 28.6,14.1 Z" id="Shape" fill="#FFFFFF"></path>\n                    <path d="M15,30.917113 L19.9407382,27.342962 C25.4425748,25.1992356 29.1,20.0394924 29.1,14.1 C29.1,6.32385763 22.7761424,0 15,0 C7.22385763,0 0.9,6.32385763 0.9,14.1 C0.9,20.0394924 4.55742516,25.1992356 10.0592618,27.342962 L15,30.917113 Z M10.5930599,26.4948878 L10.4794895,26.4333272 C5.32367283,24.4503208 1.9,19.6408756 1.9,14.1 C1.9,6.87614237 7.77614237,1 15,1 C22.2238576,1 28.1,6.87614237 28.1,14.1 C28.1,19.6408756 24.6763272,24.4503208 19.5205105,26.4333272 L19.4069401,26.4948878 L15,29.682887 L10.5930599,26.4948878 Z" id="Shape" fill="#999999"></path>\n                    <circle id="Oval" fill="#00A6EE" cx="15" cy="14.1" r="10"></circle>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n';














var draggablePin = exports.draggablePin = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(dPin);
var svgDraggablePin = exports.svgDraggablePin = dPin;


//////////////////
// WEBPACK FOOTER
// ./src/utils/createCustomMapPin.js
// module id = 600
// module chunks = 0